<template lang="html">
  <iframe
    class="ec-container"
    ref="iframe"
    frameborder="0"
    allowusermedia
    sandbox="allow-same-origin allow-scripts"
    allow="microphone">
  </iframe>
</template>

<script>
import axios from 'axios'
import gameBus from '@/components/game/gameBus'
import { mapGetters } from 'vuex'

const uri = (process.env.NODE_ENV === 'production') ? 'https://apiead.mindsidiomas.com.br' : 'https://www.ead.agmonk.info'

export default {
  data() {
    return {
      ECToken: null,
      partnerKey: null,
      document: null,
      window: null,
      ready: false
    }
  },
  props: {
    topic: {
      type: Object,
      default: _ => new Object()
    },
    subTopic: {
      type: Object,
      default: _ => new Object()
    }
  },
  computed: {
    ...mapGetters({
      testMode: 'isTestMode',
      isReview: 'isReview',
      token: 'auth/getToken',
      student: 'student/GET'
    })
  },
  methods: {
    async loadECSDK () {
      const head = document.createElement('head'),
            body = document.createElement('body')

      const ecsdk = document.createElement('script')
      ecsdk.setAttribute('id', 'ecsdk')
      ecsdk.setAttribute('src', `https://www.${process.env.NODE_ENV == 'production' ? 'englishcentral' : 'qaenglishcentral' }.com/dist/sdk/sdk.js`)
      head.appendChild(ecsdk)

      const style = document.createElement('style')
      style.textContent = 'html, body { margin: 0; border: none; padding: 0; widht: 100%; height: 100%; }'
      head.appendChild(style)

      const ecDiv = document.createElement('div')
      ecDiv.setAttribute('id', 'english-central')
      body.appendChild(ecDiv)

      this.$refs.iframe.contentDocument.head.parentNode.replaceChild(head, this.$refs.iframe.contentDocument.head)
      this.$refs.iframe.contentDocument.body.parentNode.replaceChild(body, this.$refs.iframe.contentDocument.body)

      this.document = this.$refs.iframe.contentDocument
      this.window   = this.$refs.iframe.contentWindow

      await this.$delay(2000)

      if (this.window && this.window.ECSDK)
        this.ready = true
    },
    async initializeECSDK () {
      try {
        const authResponse = await axios.post(`${uri}/english-central/authenticate`, null, { headers: { 'Authorization': this.token } })

        if (!authResponse.data || !authResponse.data.valid)
          return alert('Failed to authenticate English Central')

        this.ECToken = authResponse.headers['ec-token']
        this.partnerKey = authResponse.headers['partner-key']

        while (!this.ready) {
          await this.loadECSDK()
        }

        this.window.ECSDK.setOnModeEndHandler(this.getDialogProgress)

        this.window.ECSDK.loadWidget("player", {
          partnerKey: this.partnerKey,
          partnerSdkToken: this.ECToken,
          dialogId: this.subTopic.dialog,
          lang: 'en',
          container: 'english-central'
        })

        this.getDialogProgress()
      } catch (error) {
        alert('Failed to initialize English Central')
        console.log(error)
      }
    },
    async getDialogProgress () {
      try {
        const infoResponse = await axios.get(`${uri}/english-central/dialog/progress/${this.subTopic.dialog}`, {
          headers: {
            'Authorization': this.token,
            'EC-Token': this.ECToken
          }
        })

        if (!infoResponse.data || !infoResponse.data.valid)
          return console.warn('Failed to get dialog info')

        const progress = infoResponse.data.data

        let completed = 0,
            total     = 0

        if (progress && Array.isArray(progress.activities)) {
          for (const activity of progress.activities) {
            if (activity.completed) {
              if (activity.activityPoints > 0) {
                if (activity.activityType == 'watchActivity') {
                  completed++
                  total += 100
                } else if (activity.activityType == 'learnActivity') {
                  completed++
                  total += 100
                } else if (activity.activityType == 'speakActivity') {
                  completed++
                  total += activity.activityPoints > 100 ? 100 : activity.activityPoints
                }
              }
            }
          }

          total = total / 3

          gameBus.$emit('setEnabled', completed == 3 || this.testMode || this.isReview)

          // if (completed == 3 && !this.testMode && !this.isReview && !this.subTopic.finished) {
          if (completed == 3 && !this.testMode && !this.isReview) {
            if (!this.student.teens) {
              await this.$store.dispatch("subTopic/answerQuestion", {
                finished: true,
                points: total,
                question: {}
              });
            } else {
              await this.$store.dispatch("teens/answerQuestion", {
                finished: true,
                points: total,
                question: {}
              });
            }
          }
        }
      } catch (error) {
        console.log('Failed to get dialog info')
      }
    }
  },
  created () {
    this.$store.commit('setEnglishCentral', true)
  },
  async mounted () {
    await this.initializeECSDK()
  },
  beforeDestroy () {
    this.$store.commit('setEnglishCentral', false)
  }
};
</script>

<style lang="scss" scoped>
// @import "./src/assets/css/components/selectQuestion";
// @import "./src/assets/css/components/answerSelectQuestion";
// @import "./src/assets/css/components/imageLoader";
.ec-container {
  position: absolute;
  top: 5px;
  left: 5px;
  width: calc(100% - 10px);
  height: calc(100% - 10px);

  @media screen and (max-width: 1210px) {
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/englishCentral.vue